module.exports = __webpack_public_path__ + "img/cf257ce.jpg";